import { useParams } from "react-router-dom";
import Tabs from "@/components/Tabs";
import useCapabilities, { useCanViewBeneficiariesBool } from "@/hooks/useCapabilities";
import { useFlagsLoaded } from "@/hooks/useFeatureFlags";
import { Path } from "@/router";
import { useShowPersonGrpBenefitsTab } from "./_utils";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  const { pgaId } = useParams();
  const { loaded } = useCapabilities();
  const flagsLoaded = useFlagsLoaded();
  const canViewBeneficiaries = useCanViewBeneficiariesBool();
  const showGrpTab = useShowPersonGrpBenefitsTab();

  if (!pgaId) return null;

  const tabsReady = loaded && flagsLoaded;
  const tabItems = tabsReady
    ? [
        ...(canViewBeneficiaries
          ? [{ label: "Beneficiaries", link: `/people/${pgaId}/benefits/beneficiaries` as Path }]
          : []),
        ...(showGrpTab ? [{ label: "Golf Retirement Plus", link: `/people/${pgaId}/benefits/grp` as Path }] : [])
      ]
    : [];

  return (
    <>
      {tabsReady && tabItems.length > 0 ? <Tabs showWhenSingle tabItems={tabItems} /> : null}
      <div className="flex flex-col" data-testid="tab-content">
        {children}
      </div>
    </>
  );
}
